import React, { useState } from "react";
import Modal from "../../../components/ui/Modal";
import { toast } from "react-toastify";
import UserService from "../../../service/UserService";
import { API_URL } from "helper/Constants";

const UserStatusChangeConfirmDialog = ({
  isOpen,
  onClose,
  selectedUserData,
  setSelectedUserData,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  // Handle the status change confirmation
  const handleSubmit = async () => {
    try {
      setLoading(true);

      // Determine new status - if currently active, make it blocked, if blocked make it active
      const newStatus =
        selectedUserData.status === "active" ? "inactive" : "active";

      // Create an instance of UserService
      const userService = new UserService(API_URL);

      // Call the backend API method correctly
      await userService.updateUserStatus(
        selectedUserData.id,
        newStatus
      );

  const actionText = newStatus === "blocked" ? "Deactivated" : "Activated";
        if (onSuccess) {
        onSuccess(selectedUserData._id, actionText);
      }
      onClose();
    } catch (error) {
      console.error("Error updating user status:", error);
      setResponseMsg(error.message ??
        "An error occurred during the status update. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle cancel
  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-[30rem] overflow-y-auto"
      title={
        <h2 className="font-bold text-2xl py-4">
          {selectedUserData.status === "active" ? "Deactivate" : "Activate"}{" "}
          User
        </h2>
      }
    >
      <div className="px-5 py-5 text-center">
        <p>
          Are you sure you want to{" "}
          {selectedUserData.status === "active" ? "deactivate" : "activate"}{" "}
          this user?
        </p>
        {responseMsg && (
          <div className="mt-3 p-2 bg-red-100 border border-red-300 text-red-700 rounded">
            {responseMsg}
          </div>
        )}
        <div className="flex justify-center gap-4 mt-5">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-gray-700 hover:bg-gray-600 disabled:bg-gray-400 text-white font-bold py-2 px-8 rounded-md"
          >
            {loading
              ? "Processing..."
              : selectedUserData.status === "active"
              ? "Deactivate"
              : "Activate"}
          </button>
          <button
            onClick={handleCancel}
            disabled={loading}
            className="bg-red-500 hover:bg-red-600 disabled:bg-red-400 text-white font-bold py-2 px-8 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UserStatusChangeConfirmDialog;